/**
 * Calculates the client demand for a shift.
 * Client demand is the number of workers required minus both the reported demand buffer
 * and the agency reported demand buffer.
 */
export const calculateClientDemand = (shift: {
  workers_required?: number
  reported_demand_buffer?: number | null
  agency_reported_demand_buffer?: number | null
}): number => {
  const workersRequired = shift.workers_required || 0
  const flexBuffer = shift.reported_demand_buffer ?? 0
  const agencyBuffer = shift.agency_reported_demand_buffer ?? 0

  return workersRequired - flexBuffer - agencyBuffer
}
